import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useRef } from 'react';
import abs from '../photos/bg4.jpg'
import photo2 from '../photos/PhotoMh.jpg'
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import GitHubIcon from '@mui/icons-material/GitHub';
import RedditIcon from '@mui/icons-material/Reddit';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import { Link, useHref } from 'react-router-dom';
import bg from '../photos/r9.jpeg'


import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
export default function Intro() {



    useEffect(() => {
        gsap.fromTo('.slide1',
            {
                x: "-50%",
                opacity: 0,
            },
            {
                scrollTrigger: {
                    trigger: ".intro",
                    toggleActions: "play none none none",
                    scroller: "body",
                    start: "top 20%",

                },
                x: "0",
                opacity: 1,
                duration: 2,
            }
        )

        gsap.fromTo('.sidebar',
            {
                opacity: 0,
            },
            {
                scrollTrigger: {
                    trigger: ".intro",
                    toggleActions: "play none none none",
                    scroller: "body",
                    start: "top 20%",
                    // end: "bottom 60%",
                    // markers: true

                },

                opacity: 1,
                duration: 3,
            }
        )
        gsap.fromTo('.imgu',
            {
                x: "50%"
            },
            {
                scrollTrigger: {
                    trigger: ".intro",
                    toggleActions: "play none none none",
                    scroller: "body",
                    start: "top 20%",
                    // end: "bottom 60%",
                    // markers: true

                },
                x: 0,
                duration: 1,
            }
        )
    })



    return (
        <>
            <div className="intro  container-fluid py-lg-5 py-sm-3 py-0 px-sm-3 px-0 position-relative mx-auto mt-xl-3 mt-lg-2 mt-sm-2 mt-0 mb-sm-5 mb-0 z-2">
                <div className="row p-0 m-0 w-100  align-items-sm-center align-items-end  flex-sm-row flex-row-reverse justify-content-sm-between justify-content-around ">
                    <div className=" col-lg-6 col-sm-6 col-8 m-0 pe-0  lg:p-10 md:p-6 ">
                        <h3 className='slide1 my-0 fs-lg-3 fs-4 '>Hello , I'm</h3>
                        <h1 className='slide1 mb-lg-4 mt-lg-4  mb-md-3 mt-md-3 mb-sm-2  mt-sm-2 text-sm' > Dinesh Yadav</h1>
                        <h4 className='slide1 fs-lg-4 fs-sm-5 fs-6 d-sm-none d-block ps-1 m-0'>
                            Full-Stack AI Developer
                        </h4>

                        <p className="d-md-none d-sm-block d-none aboutsm mt-md-3 mt-1 text-sm" style={{ lineHeight: "16px" }}>
                            {`Full-Stack AI Developer working with LLMs, RAG, LangChain, and LangGraph to build intelligent systems, along with scalable web applications using React, Node.js, and FastAPI.`}
                        </p>

                        <p className='mt-lg-2 mt-md-1 mt-0 p-0 d-md-block d-none slide1' style={{ lineHeight: "19px" }}>
                            {`Full-Stack AI Developer specializing in building intelligent systems using LLMs, RAG pipelines, LangChain, LangGraph, and agent-based architectures with vector databases. Experienced in developing end-to-end applications using React, TypeScript, Node.js, and FastAPI, with a strong focus on scalable backends and clean system design.`}

                            <span className='d-xl-inline d-none'>
                                {`Skilled in designing efficient data flows, retrieval systems, and real-time applications that combine AI capabilities with robust full-stack engineering.`}
                            </span>
                        </p>
                        <ul className='p-0 text-start text-white m-0 conlist '>
                            <li className='list-style-none  m-0 ms-0 p-0'><Link to={"https://www.linkedin.com/in/dinesh-yadav-264113265/"} className='text-decoration-none text-white '><LinkedInIcon className='p-1' sx={{ fontSize: 32, }} /></Link></li>

                            <li className='list-style-none  m-0 ms-0 '><Link to={"https://github.com/UvYadav04"} className='text-decoration-none text-white '><GitHubIcon className='p-1' sx={{ fontSize: 32 }} /></Link></li>
                        </ul>
                        <div className="buttoonnss flex flex-row gap-2 mt-2 place-content-start place-items-center">
                            <a href='#projects' style={{ textDecoration: "none" }} className='px-sm-3 px-2 fs-lg-5 fs-6 me-2 rounded-1 py-sm-1 py-0 d-md-inline d-none bg-white text-black '>Projects</a>
                            <a href='#contact' style={{ textDecoration: "none" }} className='px-sm-3 px-2 fs-lg-5 fs-6 me-2 rounded-1 py-sm-1 py-0 d-md-inline d-none bg-white text-black '>Contact</a>
                        </div>



                    </div>

                    <div className="image col-lg-5  col-md-6 col-sm-6 col-3 p-xl-0 p-md-4 p-sm-4 p-0   text-center">
                        <img src={photo2} className='w-100 imgu bg bg-white m-0 p-0' alt="" />
                    </div>
                </div>


            </div >
        </>
    )
}
